export const DETECT_DEV_TOOLS_FLOW = "DETECT_DEV_TOOLS_FLOW";

export const SYSTEM_MESSAGE_FLOW = "SYSTEM_MESSAGE_FLOW";
export const DISMISS_SYSTEM_MESSAGE_FLOW = "DISMISS_SYSTEM_MESSAGE_FLOW";

export const UPDATE_PROFILE_PICTURE_FLOW = "UPDATE_PROFILE_PICTURE_FLOW";
export const UPDATE_PROFILE_PICTURE_FORM = "UPDATE_PROFILE_PICTURE_FORM";

export const LOAD_STUDENT_FLOW = "LOAD_STUDENT_FLOW";
export const LOAD_STUDENT_COURSE_FLOW = "LOAD_STUDENT_COURSE_FLOW";
export const LOAD_MODULES_FLOW = "LOAD_MODULES_FLOW";
export const UPDATE_STUDENT_PAGE_ACCESSED_FLOW = "UPDATE_STUDENT_PAGE_ACCESSED_FLOW";

export const LOAD_CONFIGURATION_FLOW = "LOAD_CONFIGURATION_FLOW";
export const LOAD_LOCALIZED_LABELS_FLOW = "LOAD_LOCALIZED_LABELS_FLOW";

export const OLD_START_RECORD_FLOW = "OLD_START_RECORD_FLOW";
export const OLD_END_RECORD_FLOW = "OLD_END_RECORD_FLOW";
export const OLD_END_RECORD_BY_TIMEOUT_FLOW = "OLD_END_RECORD_BY_TIMEOUT_FLOW";

export const START_RECORD_FLOW = "START_RECORD_FLOW";
export const END_RECORD_FLOW = "END_RECORD_FLOW";
export const END_RECORD_BY_TIMEOUT_FLOW = "END_RECORD_BY_TIMEOUT_FLOW";
export const PLAY_RECORD_AUDIO_FLOW = "PLAY_RECORD_AUDIO_FLOW";
export const PLAY_HISTORY_RECORD_AUDIO_FLOW = "PLAY_HISTORY_RECORD_AUDIO_FLOW";

export const ACHIEVEMENT_EXECUTION_FORM = "ACHIEVEMENT_EXECUTION_FORM";
export const CHECK_ACHIEVEMENT_EXECUTION_FLOW = "CHECK_ACHIEVEMENT_EXECUTION_FLOW";

export const OLD_PLAY_ITEM_AUDIO_FLOW = "OLD_PLAY_ITEM_AUDIO_FLOW";

export const PLAY_ITEM_AUDIO_FLOW = "PLAY_ITEM_AUDIO_FLOW";
export const PLAY_ITEM_VIDEO_FLOW = "PLAY_ITEM_VIDEO_FLOW";
export const PLAY_ITEM_AUDIO_STRIPE_FLOW = "PLAY_ITEM_AUDIO_STRIPE_FLOW";
export const ITEM_EXECUTION_FORM = "ITEM_EXECUTION_FORM";

export const START_ITEM_INTRODUCTION_FLOW = "START_ITEM_INTRODUCTION_FLOW";

export const START_CERTIFICATION_TEST_EXECUTION_FLOW = "START_CERTIFICATION_TEST_EXECUTION_FLOW";
export const CERTIFICATION_TEST_ABILITY_EXECUTION_FORM = "CERTIFICATION_TEST_ABILITY_EXECUTION_FORM";
export const START_CERTIFICATION_TEST_ABILITY_EXECUTION_FLOW = "START_CERTIFICATION_TEST_ABILITY_EXECUTION_FLOW";
export const CLOSE_CERTIFICATION_TEST_ABILITY_EXECUTION_FLOW = "CLOSE_CERTIFICATION_TEST_ABILITY_EXECUTION_FLOW";
export const GET_NEXT_CERTIFICATION_TEST_ABILITY_ITEM_EXECUTION_FLOW =
  "GET_NEXT_CERTIFICATION_TEST_ABILITY_ITEM_EXECUTION_FLOW";
export const SAVE_CERTIFICATION_TEST_ABILITY_ITEM_EXECUTION_ANSWER_FLOW =
  "SAVE_CERTIFICATION_TEST_ABILITY_ITEM_EXECUTION_ANSWER_FLOW";
export const END_CERTIFICATION_TEST_ABILITY_EXECUTION_FLOW = "END_CERTIFICATION_TEST_ABILITY_EXECUTION_FLOW";
export const CHECK_CERTIFICATION_TEST_RESULT_FLOW = "CHECK_CERTIFICATION_TEST_RESULT_FLOW";
export const START_CERTIFICATION_TEST_TASTING_ABILITY_EXECUTION_FLOW =
  "START_CERTIFICATION_TEST_TASTING_ABILITY_EXECUTION_FLOW";

export const USER_AWAY_FLOW = "USER_AWAY_FLOW";
export const USER_AWAY_TIMEOUT_FLOW = "USER_AWAY_TIMEOUT_FLOW";
export const SHOW_USER_AWAY_MODAL = "SHOW_USER_AWAY_MODAL";
export const CLOSE_USER_AWAY_MODAL = "CLOSE_USER_AWAY_MODAL";
export const READING_TEXT_FLOW = "READING_TEXT_FLOW";

export const MONITOR_NETWORK_CONNECTION_FLOW = "MONITOR_NETWORK_CONNECTION_FLOW";

export const SELECT_ITEM_FLOW = "SELECT_ITEM_FLOW";